<template>
	<div class="d21-query-products" id="d21-query-products">
		<label class="text-header">
			{{ T("OneTicketing_how_many_people") }}
			<div :class="statusClass()">
				<i class="material-icons">confirmation_number</i>{{status}}
			</div>
		</label>
		<template v-for="product in Reservation.Products">
			<ProductTariffs :product="product" :key="product.Product" />
		</template>
		<div v-for="discount in Reservation.Discounts" :key="discount._id" class="d21-query-products-item d21-query-discount-item">
			<div class="d21-product-notAvailable" v-if="!isDiscountValid(discount)">
				<i class="material-icons">error</i>{{ discount.errorMessage }}
			</div>
			<toggle-button v-model="discount.isSelected" @change="toggleDiscount" color="#2d972d" />
			<span class="d21-product-name">{{ discount.Content.Name }}</span>
			<span class="d21-product-price">{{ discount.Amount.Value + "%" + " " + T("discount") }}</span>
			<span class="d21-product-description" v-if="discount.Content.Description">
				{{ discount.Content.Description }}
			</span>
		</div>
		<div class="d21-alternatives mdl-cell mdl-cell--12-col" v-if="checkAlternatives && Reservation.Alternatives && Reservation.Alternatives.length > 0">
			<span>{{ T("OneTicketing_alternatives") + ":" }}</span>
			<ul>
				<li v-for="alternative in Reservation.Alternatives" :key="alternative.Name">
					<span class="d21-alternatives-book" v-if="alternative.Capacity.Value > 0">
						<button class="btn btn-light" @click="bookAlternative(alternative)">
							<span>{{ T("book") }}</span>
						</button>
					</span>
					<span class="d21-alternatives-name">{{ alternative.Name }}:&nbsp;</span>
					<span :class="getAlternativeClass(alternative)">{{ alternative.Capacity.Value + " " + T("available") }}</span>
					<span class="d21-alternatives-facts">
						{{ formatShift(alternative) }} <template v-if="alternative.Distance !== -1"> | {{ formatDistance(alternative.Distance) }}</template>
					</span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import baseMixin from "@/mixins/base";
	import ProductTariffs from "@/components/partial/product-tariffs.vue";
	import moment from "moment";

	export default {
		mixins: [baseMixin],
		components: {
			ProductTariffs,
		},
		computed: {
			status() {
				// display status of a product
				if (!this.Reservation.Info.Capacity.AllUnavailable && this.Reservation.Info.Capacity.Status !== '' && !this.Reservation.Info.Capacity.AllClosed) {
					return this.T("OneTicketing_availableTickets") + ":" + this.Reservation.Info.Capacity.Value;
				} else if (this.Reservation.Info.Capacity.AllUnavailable) {
					return this.T("OneTicketing_noTickets_available");
				} else if (this.Reservation.Info.Capacity.AllClosed) {
					return this.T("OneTicketing_Product_closed");
				} else {
					return null;
				}
			}
		},
		methods: {
			statusClass() {
				return !this.Reservation.Info.Capacity.AllUnavailable && this.Reservation.Info.Capacity.Status !== '' && !this.Reservation.Info.Capacity.AllClosed ? "d21-capacity-status d21-capacity-status--" + this.Reservation.Info.Capacity.Status.toLowerCase() : 'd21-capacity-allUnavailable';
			},
			bookAlternative(alternative) {
				window.location.href = alternative.Url;
			},
			formatShift(alternative) {
				const start = moment().startOf("day").add(alternative.StartTime, "minutes").format("HH:mm");
				const end = moment().startOf("day").add(alternative.EndTime, "minutes").format("HH:mm");
				return start + "-" + end + " " + this.T("o_clock");
			},
			checkAlternatives() {
				return this.Reservation && (this.Reservation.Info.Capacity.Status == "Orange" || this.Reservation.Info.Capacity.Status == "Red" || this.Reservation.Info.Capacity.AllUnavailable);
			},
		}
	}
</script>

<style>

</style>